export const CHANGE_SIDEBAR_STATE = 'CHANGE_SIDEBAR_STATE'

export const BADGE_LIST = 'BADGE_LIST'
export const BADGE_SAVE = 'BADGE_SAVE'
export const BADGE_EDIT = 'BADGE_EDIT'

export const VIDEOS_LIST = 'VIDEOS_LIST'
export const VIDEOS_LIST_ERROR = 'VIDEOS_LIST_ERROR'
export const VIDEOS_LIST_SUCCESS = 'VIDEOS_LIST_SUCCESS'
export const VIDEOS_CREATE = 'VIDEOS_CREATE'
export const VIDEOS_CREATE_ERROR = 'VIDEOS_CREATE_ERROR'
export const VIDEOS_CREATE_SUCCESS = 'VIDEOS_CREATE_SUCCESS'
export const VIDEOS_EDIT = 'VIDEOS_EDIT'
export const VIDEOS_EDIT_ERROR = 'VIDEOS_EDIT_ERROR'
export const VIDEOS_EDIT_SUCCESS = 'VIDEOS_EDIT_SUCCESS'
export const VIDEO_EDITED = 'VIDEO_EDITED'
export const VIDEO_DELET = 'VIDEO_DELET'

export const PROJECT_START = 'PROJECT_START'
export const PROJECT_ERROR = 'PROJECT_ERROR'
export const PROJECT_LIST = 'PROJECT_LIST'
export const PROJECT_CREATE = 'PROJECT_CREATE'
export const PROJECT_SELECTED = 'PROJECT_SELECTED'
export const PROJECT_DELET = 'PROJECT_DELET'
export const PROJECT_EDITED = 'PROJECT_EDITED'
export const PROJECT_BADGE_ADD = 'PROJECT_BADGE_ADD'
export const PROJECT_BADGE_REMOVE = 'PROJECT_BADGE_REMOVE'

export const AUTH_CERRAR_SESION = 'AUTH_CERRAR_SESION'
export const AUTH_GET_USER = 'AUTH_GET_USER'
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
